<div class="ratings-container">
  <!-- Loading Spinner -->
  <!-- <app-loading-spinner 
    [isLoading]="loading" 
    message="Loading stations..."
    size="large"
    [overlay]="true">
  </app-loading-spinner> -->

  <!-- Simplified header with only back to dashboard button -->
  <div class="nav-header">
    <div class="nav-content">
      <div class="nav-brand">
        <h2>Manage Station Ratings</h2>
      </div>
      <div class="nav-menu">
        <button mat-stroked-button (click)="goBack()" class="nav-btn">
          <mat-icon>dashboard</mat-icon>
          Back to Dashboard
        </button>
      </div>
    </div>
  </div>

  <!-- Using shared station header component for consistency -->
  <app-station-header
    [stations]="stations"
    [selectedStation]="selectedStation"
    [loading]="loading"
    title="Select Station"
    subtitle="Choose a station to manage ratings"
    (stationChange)="onStationChange($event)">
  </app-station-header>

  <!-- Combined hourly ratings data section with table and buttons in same line -->
  <div class="ratings-content" *ngIf="selectedStation">
    <mat-card class="ratings-display-card">
      <!-- Header with title and action buttons in same line -->
      <div class="ratings-header">
        <h3>Hourly Ratings Data</h3>
        <div class="action-buttons" *ngIf="canManage">
          <!-- Show Add Ratings when no data, Edit Ratings when data exists -->
          <button mat-raised-button color="primary" (click)="openAddRatingsDialog()" *ngIf="!stationRatings || !stationRatings.ratings">
            <mat-icon>add</mat-icon>
            Add Ratings
          </button>
          <button mat-stroked-button (click)="openEditRatingsDialog()" *ngIf="stationRatings && stationRatings.ratings">
            <mat-icon>edit</mat-icon>
            Edit Ratings
          </button>
          <button mat-stroked-button (click)="openFileUploadDialog()">
            <mat-icon>upload_file</mat-icon>
            Upload File
          </button>
          <button mat-icon-button (click)="refreshRatings()" matTooltip="Refresh" class="refresh-btn">
            <mat-icon>refresh</mat-icon>
          </button>
          <button mat-stroked-button color="warn" (click)="deleteStationRatings()" [disabled]="!stationRatings || !stationRatings.ratings">
            <mat-icon>delete</mat-icon>
            Delete
          </button>
        </div>
      </div>

      <!-- Loading state -->
      <div class="ratings-loading" *ngIf="loadingRatings">
        <app-data-loader [show]="true" message="Loading ratings data..." size="medium" />
      </div>

      <!-- Show user-friendly message when no ratings data instead of empty table -->
      <div class="no-ratings-message" *ngIf="!loadingRatings && (!stationRatings || !stationRatings.ratings)">
        <mat-icon class="no-ratings-icon">assessment</mat-icon>
        <h4>No ratings found for this station</h4>
        <p>You can add new ratings manually or upload a file to get started.</p>
        <div class="no-ratings-actions" *ngIf="canManage">
          <button mat-raised-button color="primary" (click)="openAddRatingsDialog()">
            <mat-icon>add</mat-icon>
            Add New Ratings
          </button>
          <button mat-stroked-button (click)="openFileUploadDialog()">
            <mat-icon>upload_file</mat-icon>
            Upload File
          </button>
        </div>
      </div>

      <!-- Ratings Grid - only show when data exists -->
      <div class="ratings-data" *ngIf="!loadingRatings && stationRatings && stationRatings.ratings">
        <div class="ratings-header-info">
          <p class="last-updated" *ngIf="stationRatings.ratings.last_updated">
            Last updated: {{stationRatings.ratings.last_updated | date:'medium'}}
          </p>
        </div>

        <!-- Legend -->
        <div class="ratings-legend">
          <div class="legend-item">
            <div class="legend-color minimal"></div>
            <span>Minimal (0-99)</span>
          </div>
          <div class="legend-item">
            <div class="legend-color low"></div>
            <span>Low (100-199)</span>
          </div>
          <div class="legend-item">
            <div class="legend-color medium"></div>
            <span>Medium (200-499)</span>
          </div>
          <div class="legend-item">
            <div class="legend-color high"></div>
            <span>High (500+)</span>
          </div>
          <div class="legend-item peak">
            <mat-icon>star</mat-icon>
            <span>Peak Hours</span>
          </div>
        </div>

        <!-- Ratings Grid with horizontal scroll -->
        <div class="ratings-grid-container">
          <div class="ratings-grid">
            <!-- Hour Headers -->
            <div class="hour-header"></div>
            <div class="hour-header" *ngFor="let hour of hours" 
                 [class.peak-hour]="isPeakHour(hour)"
                 [matTooltip]="getHourDisplay(hour)">
              {{ getHourShort(hour) }}
            </div>

            <!-- Day Rows -->
            <ng-container *ngFor="let day of days; let dayIndex = index">
              <div class="day-header">
                <span class="day-name">{{dayLabels[dayIndex]}}</span>
                <span class="day-abbr">{{day}}</span>
              </div>
              
              <div class="rating-cell" 
                   *ngFor="let hour of hours"
                   [class]="'rating-' + getRatingIntensity(getRating(day, hour))"
                   [class.peak-hour]="isPeakHour(hour)"
                   [matTooltip]="dayLabels[dayIndex] + ' ' + getHourDisplay(hour) + ': ' + formatRating(getRating(day, hour)) + ' listeners'">
                <span class="rating-value">{{formatRating(getRating(day, hour))}}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- No Station Selected -->
  <mat-card class="no-station-card" *ngIf="!selectedStation && !loading">
    <div class="no-station-content">
      <mat-icon class="no-station-icon">radio</mat-icon>
      <h3>Select a Station</h3>
      <p>Choose a station from the dropdown above to view and manage its ratings data.</p>
    </div>
  </mat-card>
</div>
